
const NotFound = () => {
  return (
    <section className="max-w-7xl page-container text-center text-lg font-semibold">Error 404, Page Not Found</section>
  )
}

export default NotFound